import AttemptsIndicator from "./AttemptsIndicator";

export default AttemptsIndicator;
